import React from 'react';
import MuiTypography, {
  TypographyProps as MuiTypographyProps,
} from '@mui/material/Typography';

/**
 * `Typography` component extends Material UI's `Typography` and adds custom props.
 *
 * @param {MuiTypographyProps} props - The properties passed to the component
 * @returns {React.ReactElement} The rendered `Typography` component with dynamic text
 *
 * @category Component
 * @document TypographyComponentUsage.md
 */
export const Typography = ({
  ...props
}: MuiTypographyProps): React.ReactElement => {
  return <MuiTypography {...props} />;
};
